import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { map, isEmpty, find, lowerCase, get } from 'lodash';
import { Row, Col, Form, Button } from 'react-bootstrap';

import { MAPSERVERELEMENTS_TYPES } from '../../../api/MapServerElements/MapServerElements';
import {
  getId,
  getName,
  getType,
  getMapServerUrl
} from '../../../api/MapServerElements/map-server-element-operations';

import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';

import Validation from '../../containers/Validation';
import LayerDefaultURLField from '../../atoms/LayerDefaultURLField';

class MapServerElementEditor extends Component {
  state = {
    mapServerElementUrl: getMapServerUrl(this.props.mapServerElement),
    mapServerElementTypeList: [],
    mapServerElementUrlList: []
  };

  async componentDidMount() {
    await this.getMapServerElementLists();
  }

  getMapServerElementLists = async () => {
    const { mapServerElement } = this.props;
    try {
      const mapServerElementTypeList = await methodPromise('mapServerElements.getTypeList');
      const mapServerElementType = getType(mapServerElement);
      const { id: typeId } = find(
        mapServerElementTypeList,
        ({ name }) => lowerCase(name.trim()) === lowerCase(mapServerElementType)
      );

      const mapServerElementUrlList = await methodPromise('mapServerElements.getTypeList', typeId);
      this.setState({ mapServerElementUrlList, mapServerElementTypeList });
    } catch (error) {
      handleErrorInClient(error);
      this.setState({ mapServerElementUrlList: [], mapServerElementTypeList: [] });
    }
  };

  handleTypeChange = async event => {
    const { mapServerElementTypeList } = this.state;
    const newType = event.target.form.type.value;
    try {
      const typeId = get(
        find(mapServerElementTypeList, ({ name }) => lowerCase(name.trim()) === lowerCase(newType)),
        'id',
        ''
      );
      if (isEmpty(typeId)) {
        this.setState({ mapServerElementUrlList: [] });
      } else {
        const mapServerElementUrlList = await methodPromise(
          'mapServerElements.getTypeList',
          typeId
        );
        this.setState({ mapServerElementUrlList });
      }
    } catch (error) {
      handleErrorInClient(error);
      this.setState({ mapServerElementUrlList: [] });
    }
  };

  handleSubmit = async form => {
    const { mapServerElement } = this.props;
    const { mapServerElementUrl } = this.state;

    const existingMapServerElement = getId(mapServerElement);
    const methodToCall = existingMapServerElement
      ? 'mapServerElements.update'
      : 'mapServerElements.insert';

    const newMapServerElement = {
      name: form.name.value.trim(),
      type: form.type.value,
      url: mapServerElementUrl
    };

    if (existingMapServerElement) newMapServerElement._id = existingMapServerElement;

    try {
      const mapServerElementId = await methodPromise(methodToCall, newMapServerElement);
      this.redirectToMapServerElementView(form, existingMapServerElement, mapServerElementId);
    } catch (error) {
      handleErrorInClient(error);
    }
    return true;
  };

  handleUrlChange = event => this.setState({ mapServerElementUrl: event.target.value.trim() });

  redirectToMapServerElementView(form, existingMapServerElement, mapServerElementId) {
    const { history } = this.props;
    const confirmation = existingMapServerElement ? 'Layer Server updated!' : 'Layer Server added!';
    form.reset();
    Bert.alert(confirmation, 'success');
    history.push(`/layerServers/${mapServerElementId}`);
  }

  render() {
    const { mapServerElement } = this.props;
    const { mapServerElementUrlList, mapServerElementUrl } = this.state;
    const isNewMapServerElement = isEmpty(getId(mapServerElement));

    const validationProps = {
      rules: {
        name: {
          required: true
        },
        type: {
          required: true
        },
        url: {
          required: true
        }
      },
      messages: {
        name: {
          required: 'Need a name in here, Seuss'
        },
        type: {
          required: 'This needs a type please'
        },
        url: {
          required: 'This needs a layer server URL, please'
        }
      },
      submitHandler: form => {
        this.handleSubmit(form);
      }
    };

    return (
      <>
        <Row>
          <Col xs={12} md={6} lg={4}>
            <Validation {...validationProps}>
              <Form onSubmit={event => event.preventDefault()}>
                <Form.Group>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    defaultValue={getName(mapServerElement)}
                    name="name"
                    placeholder="Oh, The Places You'll Go!"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Type</Form.Label>
                  <Form.Control
                    as="select"
                    defaultValue={getType(mapServerElement)}
                    name="type"
                    onChange={this.handleTypeChange}
                  >
                    {map(MAPSERVERELEMENTS_TYPES.properties, ({ value, humanValue }) => (
                      <option value={value} key={value}>
                        {humanValue}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                <Form.Group>
                  <Form.Label> Layer Server Url</Form.Label>
                  <LayerDefaultURLField
                    mapServerElementUrlList={mapServerElementUrlList}
                    mapServerElementUrl={mapServerElementUrl}
                    handleUrlChange={this.handleUrlChange}
                  />
                  <Form.Control
                    value={mapServerElementUrl}
                    name="url"
                    placeholder="The URL of the Layer Server"
                    onChange={this.handleUrlChange}
                  />
                </Form.Group>

                <Button type="submit" variant="outline-success">
                  {isNewMapServerElement ? 'Add Layer Server' : 'Save Changes'}
                </Button>
              </Form>
            </Validation>
          </Col>
        </Row>
      </>
    );
  }
}

MapServerElementEditor.defaultProps = {
  mapServerElement: {
    name: '',
    type: MAPSERVERELEMENTS_TYPES.GEOJSON,
    mapServerUrl: ''
  }
};

MapServerElementEditor.propTypes = {
  mapServerElement: PropTypes.object,
  history: PropTypes.object.isRequired
};

export default MapServerElementEditor;
